import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { PartnerAggregatedHeaderFragment } from '../../fragments/PartnerAggregatedHeader'
import { LoadingArea } from '../../components/LoadingArea'
import { ErrorMessage } from '../../fragments/Timeline'
import { EmptyMessage } from '../structure/StructureStructure'
import { PartnerVolumeChart } from '../structure/charts/Volume'
import { PartnerBalanceChart } from '../structure/charts/Balance'
import { PartnerDepositWithdrawalsChart } from '../structure/charts/DepositWithdrawals'
import { PartnerProfitChart } from '../structure/charts/Profit'
import { PartnerFeesChart } from '../structure/charts/Fees'

import { Use as PartnerCountsData } from '../../data/partners/byId/counts'

export const PartnerDataPage: React.FunctionComponent<{}> = () => {
    const { t } = useTranslation(localStorage.getItem('localeBranch'))
    const { partnerId } = useParams()

    const { loading, error, data } = PartnerCountsData(partnerId)

    if (loading) return <LoadingArea size={400} />
    if (error) return <ErrorMessage><span>⚠</span> {t('error.error')}</ErrorMessage>

    const { sbibs, bibs, ibs, clients } = data

    if (!sbibs && !bibs && !ibs && !clients) return <EmptyMessage>{t('error.noStructure')}</EmptyMessage>

    return <>
        <PartnerAggregatedHeaderFragment partnerId={partnerId} />

        <PartnerVolumeChart partnerId={partnerId} tkey="structure" />
        <PartnerBalanceChart partnerId={partnerId} tkey="structure" />
        <PartnerDepositWithdrawalsChart partnerId={partnerId} tkey="structure" />
        <PartnerProfitChart partnerId={partnerId} tkey="structure" />
        <PartnerFeesChart partnerId={partnerId} tkey="structure" />

    </>
}

